import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Branding from 'styles/Branding';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import StylesProvider from '@mui/styles/StylesProvider';
import createGenerateClassName from '@mui/styles/createGenerateClassName';
import GlobalCss from './GlobalCss';

const generateClassName = createGenerateClassName({
  productionPrefix: 'rsmain',
  disableGlobal: true,
});

const themeConfig = mode => {
  const theme = {
    typography: {
      fontFamily: 'Raleway, sans-serif',
    },
  };
  Object.assign(
    theme,
    mode === 'light'
      ? {
          palette: {
            mode,
            primary: {
              main: Branding.primaryBlue,
            },
            secondary: {
              main: Branding.primaryOrange,
              contrastText: Branding.grey[100],
            },
            background: {
              paper: Branding.grey[100],
            },
          },
        }
      : {
          palette: {
            mode,
            primary: {
              main: Branding.primaryOrange,
              contrastText: Branding.grey[100],
            },
            secondary: {
              main: Branding.primaryBlue,
            },
            background: {
              default: Branding.depricatedDefaultBackground,
              paper: Branding.depricatedPaperBackground,
            },
          },
        },
  );
  return theme;
};

const Theme = ({ themeType = 'dark', children, ...props }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(
    () => createTheme(themeConfig(prefersDarkMode ? 'dark' : themeType)),
    [prefersDarkMode, themeType],
  );

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme} {...props}>
        <GlobalCss />
        {children}
      </ThemeProvider>
    </StylesProvider>
  );
};

Theme.propTypes = {
  themeType: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Theme;
